// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from "react-redux";
import { apartmentBookingApiSlice } from "../../api/apartment/apartmentApiSlice";
import ErrorTracker from "../helpers/errorTracker";
import Logger from "../helpers/logger";
import { setAllApartment } from "../slice/apartmentRental/apartmentRentalSlice";
import {
  setLoader
} from "../slice/bookingCreation/bookingCreationSlice";
import { baseStore, RootState } from "../store"; // Adjust the import based on your file structure
import moment, { Moment } from "moment";
const fetchVenuesByCityCall = async (
  city: string,
  fromDate: string,
  toDate: string,
  numberOfGuests: number
) => {
  const data = await baseStore.dispatch(
    apartmentBookingApiSlice.endpoints.getVenueByCityList.initiate({
      city: city,
      fromDate: fromDate,
      toDate: toDate,
      numberOfGuests: numberOfGuests,
    })
  );
  return data;
};

const fetchVenuesByCityAndDistrictCall = async (
  city: string,
  district: string,
  fromDate: string,
  toDate: string,
  numberOfGuests: number
) => {
  const data = await baseStore.dispatch(
    apartmentBookingApiSlice.endpoints.getVenueByCityAndDistrictList.initiate({
      city: city,
      district: district,
      fromDate: fromDate,
      toDate: toDate,
      numberOfGuests: numberOfGuests,
    })
  );
  return data;
};

export const useFetchVenues = () => {
  const dispatch = useDispatch();

  const roomRentalLocation = useSelector(
    (state: RootState) => state.bookingCreation.roomRentalLocation
  );
  const checkInDate = useSelector(
    (state: RootState) => state.bookingCreation.orderData.checkInDate
  );
  const checkOutDate = useSelector(
    (state: RootState) => state.bookingCreation.orderData.checkOutDate
  );
  const startTime = useSelector(
    (state: RootState) => state.bookingCreation.orderData.startTime
  );
  const endTime = useSelector(
    (state: RootState) => state.bookingCreation.orderData.endTime
  );
  
  const getDateTime = (date: Moment | string | null, time: string | null | undefined) => {
    if (!date || !time || time === "0") return null;

    // ensure we always work with a moment instance
    const momentDate = moment(date);

    const [hours, minutes] = time.split(":").map(Number);
    return momentDate.clone().hour(hours).minute(minutes).second(0);
  };


  const combinedStartDateTime = getDateTime(checkInDate, startTime ?? null);
  const combinedEndDateTime = getDateTime(checkOutDate, endTime ?? null);
  const numberOfGuests = useSelector(
    (state: RootState) => state.apartment.numberOfGuest
  );

  const fetchVenues = async () => {
    try {
      dispatch(setLoader(true));
      let apartments;
      let data;

      if (roomRentalLocation.district === "all") {
        data = await fetchVenuesByCityCall(
          roomRentalLocation.city!,
          combinedStartDateTime ? combinedStartDateTime.toISOString() : "",
          combinedEndDateTime ? combinedEndDateTime.toISOString() : "",
          numberOfGuests
        );
      } else {
        data = await fetchVenuesByCityAndDistrictCall(
          roomRentalLocation.city!,
          roomRentalLocation.district!,
          combinedStartDateTime ? combinedStartDateTime.toISOString() : "",
          combinedEndDateTime ? combinedEndDateTime.toISOString() : "",
          numberOfGuests
        );
      }
      if (data) {
        apartments = data.data;
      }
      if (apartments) {
        dispatch(setAllApartment(apartments));
      }
      console.log("Apartments fetched successfully", apartments);
      dispatch(setLoader(false));
      return apartments;
    } catch (error) {
      Logger.for("fetchApartments").error(error);
      dispatch(setLoader(false));
      ErrorTracker.trackException(error as Error);
    }
  };

  return fetchVenues;
};
